<template>
  <base-modal
    :show="open"
    :title="$t('CreateFolder')"
    @on-confirm="createFolder()"
    @on-cancel="hide()"
    maxWidth="30%"
    :okText="$t('Save')"
    :closeText="$t('Close')"
  >
    <v-row justify="center" align="center" v-if="loading">
      <div class="text-center">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-row>
    <v-row justify="center" align="center" v-if="!loading">
      <v-col>
        <v-text-field v-model="folderName" :label="$t('FolderName')" />
      </v-col>
    </v-row>
    <v-row
      justify="center"
      align="center"
      v-if="!loading && refreshToken == ''"
    >
      <v-col>
        <v-text-field v-model="folderPath" :label="$t('FolderPath')" />
      </v-col>
    </v-row>
  </base-modal>
</template>
<script>
import AutoImportService from "@/services/AutoImportService";

export default {
  data() {
    return {
      open: false,
      loading: false,
      refreshToken: "",
      folderName: "",
      folderPath: "",
    };
  },
  methods: {
    show(token) {
      this.open = true;
      if (token != undefined) {
        this.refreshToken = token;
      }
    },
    hide() {
      this.open = false;
      this.loading = false;
    },
    createFolder() {
      this.loading = true;
      var createFolder = {
        RefreshToken: this.refreshToken,
        FolderName: this.folderName,
        FolderPath: this.folderPath,
      };
      if (this.refreshToken != "" && this.refreshToken != undefined) {
        AutoImportService.createFolderOneDrive(createFolder).then((x) => {
          this.$emit("on-saved");
          this.hide();
        });
      } else {
        AutoImportService.createFolderFileSystem(createFolder).then((x) => {
          this.$emit("on-saved");
          this.hide();
        });
      }
    },
  },
};
</script>
